import * as yup from "yup";
import { TFunction } from "i18next";

export default function extendTrialSchema(t: TFunction) {
  return yup.object().shape({
    date: yup.date().required(),
  });
}
